import * as React from "react";
import Header from "./header";
import Footer from "./footer";
export default class Layout extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "Site" },
            React.createElement(Header, null),
            React.createElement("div", { className: "Content" }, this.props.children),
            React.createElement(Footer, null)));
    }
}
;
//# sourceMappingURL=layout.js.map